import {useRef, useState} from 'react';
import type {RouteComponentProps} from 'react-router-dom';

import {useDebounce} from 'shells/utils/hooks/use-debounce';

import {ThreadBotStatus, ThreadType} from 'nutshell-graphql-types';

import {useGetLatestThreads} from '../graphql/hooks';
import {getThreadStatusFromSelectedTab, getContactFilterForSelectedTab} from '../helpers';
import {InboxPageContent} from '../shared-components';

interface Props extends RouteComponentProps<{page?: string; id?: string}> {
    assigneeIds: string[];
}

export function ChatbotThreadsPage(props: Props) {
    const selectedPage = props.match.params.page || 'active';
    const status = getThreadStatusFromSelectedTab(selectedPage);
    const contactFilter = getContactFilterForSelectedTab(selectedPage);
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search, 250);

    const initialThreadId = useRef(props.match.params.id).current;

    const {
        latestThreads,
        totalCount,
        isLoading: isLoadingLatestThreads,
        fetchMoreRows: fetchMoreThreads,
        hasNextPage: hasMoreThreads,
    } = useGetLatestThreads({
        status,
        assignees: props.assigneeIds,
        threadType: ThreadType.CHAT,
        findThreadId: initialThreadId || undefined,
        botStatus: ThreadBotStatus.BOT_ENABLED,
        contactFilter: contactFilter,
        search: debouncedSearch || undefined,
    });

    return (
        <InboxPageContent
            {...props}
            selectedView={selectedPage}
            latestThreads={latestThreads}
            latestThreadsTotalCount={totalCount}
            isLoadingLatestThreads={isLoadingLatestThreads}
            fetchMoreThreads={fetchMoreThreads}
            hasMoreThreads={hasMoreThreads}
            assigneeIds={props.assigneeIds}
            threadType={ThreadType.CHAT}
            search={search}
            onSearchChange={setSearch}
        />
    );
}
